import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import FormatterCommon from './formatter-common';
import LineChartFormatterCommon from './linechart-formatter-common';


    function CapacityTrendChartFormatter(params, observableOptions) {
        var self = this;
        self.chartFormatterCommon = new LineChartFormatterCommon();
        self.formatterCommon = FormatterCommon;
        self.observableFormattedData = ko.observable({});
        self.observableOptions = observableOptions;
        self.subscriptions = [];
        self.type = params.type;
    }

    CapacityTrendChartFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CapacityTrendChartFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    CapacityTrendChartFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    CapacityTrendChartFormatter.prototype.initialize = function (dataRepository) {
        var self = this;
        var source;

        self.dataRepository = dataRepository;

        if (self.type === 'PexipLocations') {
            source = dataRepository.systemStatusDataPexipLocations;

        } else {
            source = dataRepository.systemTrendDictionary;
        }

        self.subscriptions.push(source.subscribe(function () {
            self.DataUpdated();
        }));

        // initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!_.isEmpty(dataRepository.systemTrendDictionary())) {
            self.RefreshData();
        }
    };

    CapacityTrendChartFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    CapacityTrendChartFormatter.prototype.RefreshData = function () {
        var self = this;
        if (self.type === 'PexipLocations') {
            self.observableFormattedData(
                composePexipLocationCapacityLineChartData(
                    self.formatterCommon,
                    self.chartFormatterCommon,
                    self.dataRepository.systemStatusDataPexipLocations(),
                    self.observableOptions()
                )
            );

        } else {
            self.observableFormattedData(
                composeData(
                    self.formatterCommon,
                    self.chartFormatterCommon,
                    self.dataRepository.systemTrendDictionary(),
                    self.dataRepository.getDictionaryOfSystems(),
                    self.observableOptions()
                )
            );
        }
    };

    function composeData(formatterCommon, chartFormatterCommon, sourceList, dictOfSystems, options, initFlag) {
        var max = 240;
        if (!options || !options.filter || _.isEmpty(sourceList)) {
            return {
                data: [],
                legend: [],
                legendColors: [],
                lines: [],
                max: max,
                replaceMode: true,
                strokeColors: [],
                xaxislabels: []
            };

        } else {
            var systems = getSystems(options, dictOfSystems);
            var filterMaster = chartFormatterCommon.getFilterMaster(systems, options);
            var lines = chartFormatterCommon.getLines(systems, options);
            var data = getTrendData(lines, options, max, sourceList);

            return {
                data: data,
                drawYAxisLine: false,
                labelsFilter: function (value, index) {
                    if ($(window).width() < 360) {
                        return (value.split(':')[1].split(' ')[0] !== '00') || (value.split(':')[0] % 2 !== 0);

                    } else if ($(window).width() < 991) {
                        return (value.split(':')[1].split(' ')[0] !== '00');

                    } else {
                        return (value.split(':')[1].split(' ')[0] % 30 !== 0);
                    }
                },
                legend: filterMaster,
                legendColors: chartFormatterCommon.getLegendColors(filterMaster, lines),
                lines: lines,
                max: max,
                pointHitDetectionRadius: 0,
                replaceMode: true,
                scaleBeginAtZero: true,
                strokeColors: chartFormatterCommon.getLineColors(filterMaster, lines),
                xaxislabels: getLabels(max, sourceList),
                xaxisstep: 24
            };
        }
    }

    function composePexipLocationCapacityLineChartData(formatterCommon, chartFormatterCommon, sourceList, options, initFlag) {
        var pexipIds = [];
        if (!_.isEmpty(sourceList)) {
            pexipIds = Object.keys(sourceList);
        }

        if (_.isEmpty(sourceList)) {
            return {
                pointDot: true,
                max: 10,
                replaceMode: false,
                xaxislabels: [],
                legend: [],
                legendColors: chartFormatterCommon.linechartcolorlist,
                lines: [],
                data: [], //series1-label1-val1, series1-label2-val2, series2-label1-val3, ...
                strokeColors: [formatterCommon.RED, formatterCommon.BLUE]
            };

        } else {
            // => ! NOTE: when this is changed, the shift logic for summarydata should change as well
            var initlabels = chartFormatterCommon.GenerateTimeline(8);
            // var initlabels = ['-8 min', '-7 min', '-6 min', '-5 min', '-4 min', '-3 min', '-2 min', '-1 min', 'Now'];
            var sourcelines = [];
            pexipIds.forEach(function (pexipId) {
                var locations = sourceList[pexipId];
                if (locations && locations.length > 0) {
                    var location = locations[0];
                    location.forEach(function (locItem) {
                        sourcelines.push(locItem.Name);
                    });
                }
            });

            var lines = sourcelines;
            var filteredlines = lines;
            var linechartdata = [];
            var max = initlabels.length; // 33

            for (var i = 0; i < lines.length; i++) {
                linechartdata[i] = [];
                for (var j = 0; j < max; j++) {
                    linechartdata[i].push(null);
                }
            }

            if (options && options.filter) {
                filteredlines = chartFormatterCommon.getLines(lines, options);
            }

            var startindex = 0;

            pexipIds.forEach(function (pexipId) {
                var locations = sourceList[pexipId];
                if (locations && locations.length > 0) {
                    if (locations.length > max) {
                        startindex = locations.length - max;
                    }

                    for (var k = startindex; k < locations.length; k++) {
                        var newvalues = [];
                        var location = locations[k];
                        location.forEach(function (locItem) {
                            if ($.inArray(locItem.Name, filteredlines) > -1) {
                                var value = locItem.MediaLoad;
                                newvalues.push([Math.round(value * 100)]);
                            }
                        });
                        linechartdata = formatterCommon.shiftValues(linechartdata, newvalues);
                    }
                }
            });

            return {
                data: linechartdata,
                drawYAxisLine: true,
                labelsFilter: function (value, index) {
                    if ($(window).width() <= 991) {
                        return (index % 8) !== 0;

                    } else {
                        return (index % 4) !== 0;
                    }
                },
                legend: lines,
                legendColors: chartFormatterCommon.getLegendColors(lines, filteredlines),
                lines: filteredlines,
                max: 10,
                pointDot: true,
                pointHitDetectionRadius: 10,
                replaceMode: true,
                scaleBeginAtZero: true,
                scaleMax: 100,
                strokeColors: chartFormatterCommon.getLineColors(lines, filteredlines),
                xaxislabels: initlabels,
                xaxisstep: 4,
                ylabelSuffix: '%'
            };
        }
    }

    function defaultIfEmpty(item, defaultValue) {
        if (_.isNil(item) || item === '') {
            return defaultValue;

        } else {
            return parseInt(item);
        }
    }

    function getLabels(max, systemTrendDictionary) {
        var keys = Object.keys(systemTrendDictionary);
        var key = keys[0];
        var labels = [];
        var list = systemTrendDictionary[key];
        if (list.length > max) {
            list = list.slice(list.length - max);
        }
        for (var i = 0; i < list.length; i++) {
            var dt = new Date(list[i].time);
            labels.push(getTimeString(dt));
        }
        return labels;
    }

    function getSystems(options, dict) {
        var result = [];
        var newcat = options.category;

        if (newcat === 'VCS') {
            newcat = 'VCS Control';

        } else if (newcat === 'VCSX') {
            newcat = 'VCS Expressway';
        }

        if (newcat && dict && dict[newcat]) {
            result = dict[newcat];
        }

        return result;
    }

    function getTimeString(dt) {
        var currentTime = dt || new Date();
        var hours = ('0' + currentTime.getHours()).slice(-2);
        var minutes = ('0' + currentTime.getMinutes()).slice(-2);
        var ampm = 'AM';
        if (currentTime.getHours() > 12) {
            hours = ('0' + (currentTime.getHours() - 12)).slice(-2);
        }
        if (currentTime.getHours() >= 12) {
            ampm = 'PM';
        }
        return hours + ':' + minutes + ' ' + ampm;
    }

    function getTrendData(lines, options, max, sourcelist) {
        return _.map(lines, function (lineItem) {
            var list = sourcelist[lineItem];
            if (list.length > max) {
                list = list.slice(list.length - max);
            }
            return _.map(list, function (trendItem) {
                var value = null;
                switch (options.display) {
                    case 'Audio Port':
                        value = trendItem.AudioOnlyPortNow;
                        break;

                    case 'Call Licenses Used':
                    case 'Video Port':
                        value = trendItem.VideoPortNow;
                        break;

                    case 'Calls':
                        value = trendItem.CallNow;
                        break;

                    case 'coSpaces':
                    case 'Spaces':
                        value = trendItem.CallsNow;
                        break;

                    case 'CRC Port':
                        value = trendItem.CrcPortNow;
                        break;

                    case 'Non Traversal Calls':
                        value = trendItem.NTCallNow;
                        break;

                    case 'Participants':
                        value = trendItem.ParticipantsNow;
                        break;

                    case 'Screens':
                        value = (trendItem.MediaCreditsAllocatedNow / 2560).toFixed(2);
                        break;

                    case 'Total Meetings':
                        value = _.get(trendItem, 'TotalMeetings');
                        break;

                    case 'Total Participants':
                        value = _.get(trendItem, 'TotalParticipants');
                        break;

                    case 'Traversal Calls':
                        value = trendItem.TCallNow;
                        break;
                }
                return defaultIfEmpty(value, null);
            });
        });
    }

    export default CapacityTrendChartFormatter;
